export default __webpack_public_path__ + "static/media/dtg.d268c8ef.svg";